import { createRoot } from 'react-dom/client';
import { captureException } from '@sentry/browser';

import { App } from './App';
import '../shared/utils/i18n';

const selector = '.algolia-collection-grid';

const container = document.querySelector(selector);

document.addEventListener('DOMContentLoaded', () => {
  if (container) {
    const root = createRoot(container);

    root.render(<App />);
  } else {
    captureException(new Error(`Could not find ${selector}`));
  }
});
